import React, { useEffect, useState } from "react";
import { Modal, ModalDialog, Select, Option, Input, Button } from "@mui/joy";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { postFetch } from "../../../../../fetch/fetch";

/**
 * 윈터 스쿨 등록 관리 > '수동 추가하기' 팝업 — 지점 select + 이름 + 전화번호 → POST /dashboard/winterSchoolPrereserve/manual
 * 서버가 isManual = 1 로 저장하고(알림톡 없음) 저장된 행을 돌려주면 부모(onSuccess)가 목록 맨 위에 넣는다.
 * props: open, onClose, branches(string[]), onSuccess(row)
 */

const toastOptions: any = {
    position: "bottom-right",
    autoClose: 3000,
    hideProgressBar: true,
    theme: "colored",
};

const WinterManualAddModal: React.FC<any> = (props) => {

    const [location, setLocation] = useState<string>("");
    const [name, setName] = useState<string>("");
    const [phoneNumber, setPhoneNumber] = useState<string>("010");
    const [loading, setLoading] = useState<boolean>(false);

    // 모달 열릴 때 입력값 초기화
    useEffect(() => {
        if (props.open) {
            setLocation("");
            setName("");
            setPhoneNumber("010");
            setLoading(false);
        }
    }, [props.open]);

    const digits = phoneNumber.replace(/[^0-9]/g, "");
    const canSubmit = !!location && name.trim().length > 0 && digits.length >= 10 && digits.length <= 11;

    const submit = async () => {
        if (!canSubmit || loading) return;
        try {
            setLoading(true);
            const result: any = await postFetch("/dashboard/winterSchoolPrereserve/manual", {
                location,
                name: name.trim(),
                phoneNumber: digits,
            });
            if (result.message === "success" && result.data) {
                toast.success(`${result.data.name} 신청을 추가했습니다`, toastOptions);
                props.onSuccess && props.onSuccess(result.data);
                props.onClose && props.onClose();
            } else {
                console.log(result);
                toast.error("추가에 실패했습니다. 다시 시도해 주세요.", toastOptions);
            }
        } catch (e) {
            console.log(e);
            toast.error("추가에 실패했습니다. 다시 시도해 주세요.", toastOptions);
        } finally {
            setLoading(false);
        }
    };

    return (
        <Modal open={!!props.open} onClose={props.onClose}>
            <ModalDialog>
                <div style={{ width: "300px" }}>
                    <div style={{ fontSize: "18px", fontWeight: 600, marginBottom: "6px" }}>
                        수동 추가하기
                    </div>
                    <div style={{ fontSize: "13px", color: "#6B7684", marginBottom: "18px" }}>
                        알림톡은 발송되지 않고, 일별 추이 그래프에는 합산되지 않습니다.
                    </div>

                    <div style={{ fontSize: "13px", marginBottom: "6px" }}>지점</div>
                    <Select
                        placeholder="지점 선택"
                        value={location || null}
                        onChange={(e, value) => setLocation(value ? String(value) : "")}
                        sx={{ marginBottom: "14px" }}
                    >
                        {(props.branches || []).map((b: string) => (
                            <Option key={b} value={b}>{b}</Option>
                        ))}
                    </Select>

                    <div style={{ fontSize: "13px", marginBottom: "6px" }}>이름</div>
                    <Input
                        placeholder="이름"
                        value={name}
                        onChange={(e) => setName(e.target.value)}
                        sx={{ marginBottom: "14px" }}
                    />

                    <div style={{ fontSize: "13px", marginBottom: "6px" }}>전화번호</div>
                    <Input
                        placeholder="01012345678"
                        value={phoneNumber}
                        onChange={(e) => setPhoneNumber(e.target.value.replace(/[^0-9]/g, ""))}
                        onKeyDown={(e) => { if (e.key === "Enter") submit(); }}
                    />

                    <div style={{ marginTop: "25px", display: "flex", gap: "8px" }}>
                        <Button variant="outlined" color="neutral" fullWidth onClick={props.onClose} disabled={loading}>
                            취소
                        </Button>
                        <Button variant="solid" fullWidth onClick={submit} loading={loading} disabled={!canSubmit}>
                            등록하기
                        </Button>
                    </div>
                </div>
            </ModalDialog>
        </Modal>
    );
};

export default WinterManualAddModal;
